import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { formatApiError } from '../lib/api';

const OAuthCallback = () => {
  const { provider } = useParams();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithOAuthCode } = useAuth();
  const done = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const code = params.get('code');
    const state = params.get('state');
    if (!code || !state) {
      setError(params.get('error_description') || 'Innlogginga vart avbroten.');
      return;
    }
    loginWithOAuthCode(provider, code, state)
      .then((result) => { if (!result?.mfa_required) navigate('/medlem', { replace: true }); })
      .catch((e) => setError(formatApiError(e, 'Innlogginga feila.')));
  }, [provider, params, navigate, loginWithOAuthCode]);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center text-white" data-testid="oauth-callback">
      {error ? (
        <div className="text-center space-y-4">
          <p className="text-red-300" data-testid="oauth-callback-error">{error}</p>
          <button onClick={() => navigate('/login')} className="px-6 py-3 rounded-full bg-[#ff2e2e] text-black font-bold">Til innlogging</button>
        </div>
      ) : (
        <p className="text-white/60">Loggar deg inn…</p>
      )}
    </div>
  );
};

export default OAuthCallback;
